'use strict';

/**
 * Module dependencies.
 */

exports.clone = function(opts) {
  const options = {};
  opts = opts || {};
  for (const key in opts) {
    options[key] = opts[key];
  }
  return options;
};
